<template>
  <div class="customized-wrapper modifiers-wrapper">
    <!-- For Single selection modifiers -->
    <template v-if="itemModifierGroups(item)">
      <div
        class="single-select-section"
        v-for="(group, key) in itemModifierGroups(item)"
        :key="key"
      >
        <template v-if="itemModifierSubgroupsByGroup(group)">
          <div
            class="customized-box single-select"
            v-for="(subgroup, key) in itemModifierSubgroupsByGroup(group)"
            :key="key"
          >
            <template v-if="modifiersInSubgroup(group, subgroup)">
              <h6 class="title">
                {{ _T_DB(subgroup, 'name') }}
                <span class="optional" v-if="subgroup.item_type != 'mandatory'">
                  ({{ _T('OPTIONAL') }})</span
                >
                <span class="right"
                  >{{ subgroupType(subgroup) }} ({{
                    subgroup.no_of_selection >
                    itemModifiersByGroupSubGroup(group, subgroup).length
                      ? itemModifiersByGroupSubGroup(group, subgroup).length
                      : subgroup.no_of_selection
                  }})</span
                >
              </h6>
              <span
                class="validation-error"
                v-if="modifier_errors[subgroup._id]"
                :ref="'modifier_sub_group_' + subgroup._id"
                >{{ modifier_errors[subgroup._id] }}</span
              >
              <span v-if="errors[subgroup._id]">
                {{ errors[subgroup._id] }}
              </span>
              <template v-if="itemModifiersByGroupSubGroup(group, subgroup)">
                <ul class="row">
                  <template
                    v-for="(modifier, key) in itemModifiersByGroupSubGroup(
                      group,
                      subgroup
                    )"
                  >
                    <li class="col-md-6 col-6" :key="key">
                      <checkbox
                        v-model="modifiersSelection[modifier._id]"
                        :value="subgroup._id"
                        v-if="subgroup.no_of_selection !== 1"
                        @change="validateSelection(modifier, group, subgroup)"
                      >
                        <img
                          v-if="modifier.item_modifier_image"
                          :src="modifier.item_modifier_image"
                          class="img-fluid modifier-image"
                        />
                        <div
                          v-else
                          class="img-fluid modifier-image"
                          :style="{
                            backgroundColor: modifier.item_modifier_color,
                          }"
                        ></div>
                        <div class="content">
                          <span class="title" :title="_T_DB(modifier, 'name')">
                            {{ _T_DB(modifier, 'name') }}
                          </span>
                          <span class="price" v-if="modifier.value">
                            {{ currency }}
                            {{
                              Num.price(
                                tax_price(item.tax_sum, modifier.value),
                                true
                              )
                            }}
                          </span>
                        </div>
                      </checkbox>
                      <radio-group
                        v-model="modifiersSelection[subgroup._id]"
                        :id="modifier._id"
                        v-else
                      >
                        <img
                          v-if="modifier.item_modifier_image"
                          :src="modifier.item_modifier_image"
                          class="img-fluid modifier-image"
                        />
                        <div
                          v-else
                          class="img-fluid modifier-image"
                          :style="{
                            backgroundColor: modifier.item_modifier_color,
                          }"
                        ></div>
                        <div class="content">
                          <span class="title" :title="_T_DB(modifier, 'name')">
                            {{ _T_DB(modifier, 'name') }}
                          </span>
                          <span class="price" v-if="modifier.value">
                            {{ currency }}
                            {{
                              Num.price(tax_price(item.tax_sum, modifier.value))
                            }}
                          </span>
                        </div>
                      </radio-group>
                    </li>
                  </template>
                </ul>
              </template>
            </template>
          </div>
        </template>
      </div>
    </template>
    <ExtraInstruction></ExtraInstruction>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus'
import { isObjectEmpty } from '@/utils/main_utils'
import { mapState, mapGetters } from 'vuex'
import ExtraInstruction from './extraInstruction'
import Checkbox from '@/components/Elements/Checkbox'
import RadioGroup from '@/components/Elements/RadioGroup'
export default {
  data() {
    return {
      errors: {},
      selectSingleItemClick: '',
      modifier_update: false,
    }
  },

  components: {
    ExtraInstruction,
    Checkbox,
    RadioGroup,
  },
  computed: {
    ...mapState({
      item: state => state.cart_store.selectedItem,
    }),
    ...mapGetters([
      '_T_DB',
      '_T',
      'itemModifierGroups',
      'itemModifierSubgroupsByGroup',
      'itemModifiersByGroupSubGroup',
      'modifiersInSubgroup',
      'tax_price',
      'modifier_errors',
      'item_price_set_currency',
    ]),
    modifiersSelection: {
      get() {
        return this.$store.state.cart_store.selectedModifiers
      },
      set(val) {
        this.$store.commit('SELECT_MODIFIERS', val)
      },
    },
  },
  methods: {
    modifiers_price(modifier) {
      return this.item_price_set_currency(modifier)
    },
    validateSelection(modifier, group, subgroup) {
      let subgroupId = subgroup._id
      this.errors[subgroupId] = undefined
      let modifierSelection = this.modifiersSelection
      //validate the no of selection
      //find modifiers in sub group
      const noOfSelection = subgroup.no_of_selection
      //1. find all modifiers which belongs to current sub group
      const subGroupModifiers = this.itemModifiersByGroupSubGroup(
        group,
        subgroup
      )
      //2. filter selected modifiers in that subgroup
      let selectedModifiers = 0
      for (var modId in modifierSelection) {
        if (subGroupModifiers.find(mod => mod._id === modId)) {
          //if modifier id found in subGroupModifiers
          selectedModifiers++
          if (selectedModifiers > noOfSelection) {
            delete modifierSelection[modId]
          }
        }
      }

      for (var modifierId in modifierSelection) {
        if (modifierSelection[modifierId] === false) {
          delete modifierSelection[modifierId]
        }
      }

      this.modifiersSelection = Object.assign(
        {},
        this.modifiersSelection,
        modifierSelection
      )
    },
    subgroupType(subgroup) {
      let val = subgroup.item_type
      var selection = subgroup.no_of_selection === 1 ? '' : 'Multi select'
      switch (subgroup.item_type) {
        case 'mandatory':
          val = this._T('required')
          break
        case 'regular':
        case 'price':
          val = this._T(selection)
          break
      }
      return val
    },
  },
  watch: {
    modifier_errors(val) {
      if (!isObjectEmpty(val)) {
        this.$nextTick(() => {
          const link = this.$refs['modifier_sub_group_' + Object.keys(val)[0]]
          if (link) {
            eventBus.$emit('scroll-to-modifiers-error', link[0].offsetTop)
          }
        })
      }
    },
  },
}
</script>

<style lang="scss">
.body-rtl {
  .customized-wrapper {
    .customized-box {
      .title {
        text-align: right;
      }
      ul {
        padding-left: unset;
        padding-right: 0;
      }
    }
  }
  .customized-detail {
    .customized-price {
      text-align: right;
    }
  }
  .customized-img {
    .total-box {
      text-align: left !important;
    }
  }
}
.modifiers-wrapper {
  label {
    &.checkbox-radio {
      .modifier-image {
        width: $px30;
        height: $px30;
      }
    }
  }
}
.customized-wrapper {
  /* width */
  ::-webkit-scrollbar {
    width: $px6;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track;
    border-radius: $px6;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb;
    border-radius: $px4;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: darken($scrollbar-track, 0.2);
  }
  .customized-box {
    padding: $px14 0 $px14 0;
    textarea {
      margin-top: $px15;
      border: $px1 solid $light-border;
      border-radius: $px4;
    }
    .title {
      font-style: normal;
      font-weight: 600;
      font-size: $px12;
      line-height: $px15;
      letter-spacing: 0.5px;
      color: $font-color;
      margin-bottom: 0;
      text-transform: uppercase;
      span {
        &.right {
          float: right;
          color: $color-secondary;
        }
        &.optional {
          color: $light-font;
          text-transform: capitalize;
        }
      }
    }
    ul {
      margin-left: -$px5;
      margin-right: -$px5;
      li {
        padding-left: $px5;
        padding-right: $px5;
        margin-top: $px15;
        cursor: pointer;
      }
    }
  }
}
</style>
